export default __webpack_public_path__ + "static/button_accent-1b0f727553f397395c642f992654253e.png";